import axios from 'axios';
import { ApiResponse, Feature, FeaturePermissionMatrix, PermissionUpdate, PermissionPreview } from '../types';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const featuresService = {
    getFeatures: async (): Promise<Feature[]> => {
        const token = localStorage.getItem('access_token');
        const response = await axios.get<ApiResponse<{ features: Feature[] }>>(`${API_URL}/features`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        if (response.data.error) {
            throw new Error(response.data.error);
        }
        return response.data.data?.features || (response.data as any).features || [];
    },

    getPermissions: async (): Promise<FeaturePermissionMatrix> => {
        const token = localStorage.getItem('access_token');
        const response = await axios.get<FeaturePermissionMatrix>(`${API_URL}/features/permissions`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    updatePermissions: async (updates: PermissionUpdate[]): Promise<void> => {
        const token = localStorage.getItem('access_token');
        await axios.post(`${API_URL}/features/permissions`, { updates }, {
            headers: { Authorization: `Bearer ${token}` }
        });
    },

    previewPermissionChange: async (featureId: number, roleId: number, allowed: boolean): Promise<PermissionPreview> => {
        const token = localStorage.getItem('access_token');
        const response = await axios.post<PermissionPreview>(
            `${API_URL}/features/permissions/preview`,
            { feature_id: featureId, role_id: roleId, allowed },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    },

    getMyPermissions: async (): Promise<string[]> => {
        const token = localStorage.getItem('access_token');
        const response = await axios.get<{ allowed_features: string[] }>(`${API_URL}/features/my-permissions`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data.allowed_features;
    }
};

export default featuresService;

